import { ContactSequence, Tooltip } from "@components"
import { mySqlToLocal } from "@helpers"

import { 
  CheckBadgeIcon, 
  ExclamationCircleIcon, 
  PaperAirplaneIcon,
  ShieldCheckIcon, 
  XCircleIcon 
} from "@heroicons/react/24/outline"

import { 
  CheckBadgeIcon as CheckBadgeIconSolid, 
  CheckCircleIcon as CheckCircleIconSolid, 
  PaperAirplaneIcon as PaperAirplaneIconSolid,
  ShieldCheckIcon as ShieldCheckIconSolid 
} from "@heroicons/react/24/solid"

import { Spinner } from "@heroui/react"

import PropTypes from "prop-types"

const Icons = ({ 
  activatedAt, 
  contactSequence, 
  lastEmailErrored,
  lastEmailSent,
  lastEmailQueued,
  legalGuardian,
  status 
}) => (
  <div className="flex items-center space-x-2">
    {status === "Matched" &&
      <Tooltip content="Student Matched to a Guardian"> 
        <CheckBadgeIconSolid className="text-green-400 w-9 h-9 focus:outline-none" />
      </Tooltip>
    }
    
    {status !== "Matched" && 
      <Tooltip content="Student Could not be Matched to a Guardian">
        <CheckBadgeIcon className="text-gray-400 w-9 h-9 focus:outline-none" />
      </Tooltip>
    }

    {activatedAt && 
      <Tooltip content={`Account was activated on ${mySqlToLocal(activatedAt).format("DD/MM/YYYY HH:mm")}`}>
        <CheckCircleIconSolid className="w-8 h-8 text-center text-green-400 focus:outline-none" />
      </Tooltip>
    }

    {activatedAt === null && 
      <Tooltip content={`This account has not been activated yet`}>
        <XCircleIcon className="w-8 h-8 text-center text-gray-400 focus:outline-none" />
      </Tooltip>
    }

    <Tooltip content="Contact Sequence">
      {/* div required for tooltip to work with ContactSequence component */}
      <div>
        <ContactSequence priority={contactSequence} size="sm" />
      </div>
    </Tooltip>

    {legalGuardian && 
      <Tooltip content="Legal Guardian">
        <ShieldCheckIconSolid className="w-8 h-8 text-center text-green-400 focus:outline-none" />
      </Tooltip>
    }
    
    {!legalGuardian && 
      <Tooltip content="Not a Legal Guardian">
        <ShieldCheckIcon className="w-8 h-8 text-center text-gray-400 focus:outline-none" />
      </Tooltip>
    }  

    {lastEmailErrored && (
      <Tooltip content="Last invitation email failed to send">
        <ExclamationCircleIcon className="w-8 h-8 text-center text-red-400 focus:outline-none" />
      </Tooltip>
    )}

    {lastEmailQueued && (
      <Tooltip content="Last invitation email is queued">
        <Spinner color="success" variant="simple" classNames={{"wrapper": "w-7 h-7 text-center"}} />
      </Tooltip>
    )}

    {lastEmailSent && (
      <Tooltip content="Last invitation email sent successfully">
        <PaperAirplaneIconSolid className="w-8 h-8 text-center text-green-400 focus:outline-none" />
      </Tooltip>
    )}

    {!lastEmailSent && !lastEmailQueued && !lastEmailErrored && (
      <Tooltip content="No invitation email sent yet">
        <PaperAirplaneIcon className="w-8 h-8 text-center text-gray-400 focus:outline-none" />
      </Tooltip>
    )}
  </div>
)


Icons.propTypes = {
  activatedAt: PropTypes.string,
  contactSequence: PropTypes.number.isRequired,
  legalGuardian: PropTypes.bool.isRequired,
  lastEmailErrored: PropTypes.bool.isRequired,
  lastEmailQueued: PropTypes.bool.isRequired,
  lastEmailSent: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
}

export default Icons